// Admin bulk export: same capture and PDF page settings as shareUtils.js, but returns
// blobs instead of triggering a download per card.
import jsPDF from 'jspdf';
import JSZip from 'jszip';
import { captureRecipeCard } from './captureRecipeCard';

export const BULK_FORMATS = {
  pdf: { extension: 'pdf', label: 'PDF' },
  png: { extension: 'png', label: 'PNG' },
  jpg: { extension: 'jpg', label: 'JPG' },
};

function canvasBlob(canvas, type) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Could not encode the recipe image.')),
      type, type === 'image/jpeg' ? 0.98 : undefined);
  });
}

export async function blankCardBlob(node, format) {
  const { canvas, width, height } = await captureRecipeCard(node);
  if (format === 'png') return canvasBlob(canvas, 'image/png');
  if (format === 'jpg') return canvasBlob(canvas, 'image/jpeg');

  const pageWidth = width * 72 / 96;
  const pageHeight = height * 72 / 96;
  const pdf = new jsPDF({
    orientation: width > height ? 'landscape' : 'portrait',
    unit: 'pt',
    format: [pageWidth, pageHeight],
    compress: true,
  });
  pdf.setProperties({ title: 'Recipe Card' });
  pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, pageWidth, pageHeight);
  return pdf.output('blob');
}

export function blankCardFileName(title, code, format) {
  const base = String(title || code || 'recipe-card')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'recipe-card';
  return `${base}.${BULK_FORMATS[format].extension}`;
}

export async function zipBlankCards(entries) {
  const zip = new JSZip();
  const used = new Set();
  entries.forEach(({ name, blob }) => {
    let finalName = name;
    for (let n = 2; used.has(finalName); n += 1) {
      finalName = name.replace(/(\.[^.]+)$/, `-${n}$1`);
    }
    used.add(finalName);
    zip.file(finalName, blob);
  });
  return zip.generateAsync({ type: 'blob' });
}
